import { BaseCreate } from '@/components/create';
import { BaseForm } from '@/components/form/form';
import FormField from '@/components/form/form-field';
import useLayout from '@/hooks/useLayout';
import { UseShipping } from '@/modules/check-shipping-price/application/check-shipping-price';
import { convertNumberToCurrency } from '@/utility/helper/common';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  useSnackbar,
} from '@rrexpress/core';
import { useDocumentTitle } from '@refinedev/react-router-v6';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';

export const CheckShippingPrice = () => {
  useLayout({
    title: 'Cek Ongkos Kirim',
  });
  const setTitle = useDocumentTitle();

  const userLoginData = JSON.parse(Cookies.get('user_login') as string);
  const { checkShippingPrice, loadingCreate: isLoading } = UseShipping();
  const { show } = useSnackbar();
  const [data, setData] = useState<ShipmentRoute[]>([]);

  const handleCheckShippingPrice = async (values: CalculateParcelPricePayload) => {
    setData([]);
    try {
      const res = await checkShippingPrice({
        customer_id: userLoginData.tenantId,
        ...values,
      });

      const newData: ShipmentRoute[] = res?.data?.data || [];

      if (newData) {
        console.log(newData);
        setData(newData);
      }
    } catch (error) {
      show('Harga untuk rute ini tidak tersedia', 'error');
    }
  };

  const handleOnSubmit = (values: any) => {
    handleCheckShippingPrice({
      ...values,
      weight: +values.weight,
      parcel_value: 100000,
      is_insurance: true,
      product_service_code: 'REG',
    });
  };

  useEffect(() => {
    setTitle('Cek Ongkos Kirim | Bluebird Kirim');

    return () => {
      setTitle('Bluebird Kirim');
    };
  }, []);

  return (
    <div className="min-h-[75vh]">
      <BaseCreate
        title="Cek Ongkos Kirim"
        hideBack
        isLoading={isLoading}
      >
        <>
          <BaseForm
            onFinish={handleOnSubmit}
            footer={<></>}
            initialValue={{ weight: 1 }}
          >
            <div className="flex flex-col gap-3">
              <div className="grid grid-cols-3 gap-4">
                <FormField
                  component="queryfield"
                  name="origin_id"
                  componentProps={{
                    label: 'Asal',
                    endpoint: 'cities',
                    dataProviderName: 'masterdata',
                    keyQueryFilter: 'city_name',
                    keyOptionLabel: 'city_name',
                    keyOptionValue: 'city_id',
                    required: true,
                    onSelectedOutputKey: 'value',
                  }}
                />
                <FormField
                  component="queryfield"
                  name="destination_id"
                  componentProps={{
                    label: 'Tujuan',
                    endpoint: 'destinations',
                    dataProviderName: 'masterdata',
                    keyQueryFilter: 'destination_name',
                    keyOptionLabel: 'destination_name',
                    keyOptionValue: 'destination_id',
                    required: true,
                    onSelectedOutputKey: 'value',
                  }}
                />
                <FormField
                  id="weight"
                  name="weight"
                  component="form"
                  componentProps={{
                    label: 'Berat (Kg)',
                    type: 'number',
                    required: true,
                  }}
                />
              </div>
              <div>
                <Button>Cek Ongkir</Button>
              </div>
            </div>
          </BaseForm>
          {data.length > 0 && (
            <div className="mt-4">
              <Table className="!table">
                <TableHead>
                  <TableRow>
                    <TableCell>Layanan</TableCell>
                    <TableCell>Harga/Kg</TableCell>
                    <TableCell>Total Harga</TableCell>
                    <TableCell>Min Berat</TableCell>
                    <TableCell>Max Berat</TableCell>
                    <TableCell>SLA</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(data || []).map((item: ShipmentRoute, index: any) => (
                    <TableRow>
                      <TableCell>{item.product_service_name}</TableCell>
                      <TableCell>{convertNumberToCurrency(item.price)}</TableCell>
                      <TableCell>{convertNumberToCurrency(item.total_price)}</TableCell>
                      <TableCell>{`${item.min_weight} Kg`}</TableCell>
                      <TableCell>{`${item.max_weight} Kg`}</TableCell>
                      <TableCell>{`${item.min_sla} - ${item.max_sla} Hari`}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}
        </>
      </BaseCreate>
    </div>
  );
};

export default CheckShippingPrice;
